import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import PublicRoute from "@router/PublicRoute";
// import "@static/css/style.css";
import * as Const from "@utils/Const";
import { Suspense, useEffect } from "react";
import { Navigate, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import i18n from 'i18next';
import MainPortalLayout from "@layout/MainPortalLayout";
import HomeMain from "@components/main/home/HomeMain";
import HomeMainEn from "@components/main/home/HomeMainEn";
import Login from "@components/admin/Login";
import AdminLayout from "@layout/AdminLayout";
import PrivateRoute from "./PrivateRoute";
import MenuMain from "@components/admin/management/menu/MenuMain";
import ProductMain from "@components/admin/management/product/ProductMain";
import BoardMain from "@components/admin/management/board/BoardMain";
import Contact from "@components/main/ko/notice/Contact";
import ContactDetail from "@components/main/ko/notice/ContactDetail";
import ContactWrite from "@components/main/ko/notice/ContactWrite";
import Faq from "@components/main/ko/notice/Faq";
import Notice from "@components/main/ko/notice/Notice";
import NoticeDetail from "@components/main/ko/notice/NoticeDetail";
import Detail from "@components/main/ko/products/Detail";
import Products from "@components/main/ko/products/Products";
import Company from "@components/main/ko/company/Company";
import Goals from "@components/main/ko/company/Goals";
import Registration from "@components/main/ko/company/Registration";
import ESG2023 from "@components/main/ko/esg/ESG2023";
import ESG2024 from "@components/main/ko/esg/ESG2024";
import ESG2025 from "@components/main/ko/esg/ESG2025";
import History from "@components/main/ko/company/History";
import Location from "@components/main/ko/company/Location";
import CompanyEn from "@components/main/en/company/CompanyEn";
import HistoryEn from "@components/main/en/company/HistoryEn";
import GoalsEn from "@components/main/en/company/GoalsEn";
import LocationEn from "@components/main/en/company/LocationEn";
import RegistrationEn from "@components/main/en/company/RegistrationEn";
import ESG2023En from "@components/main/en/esg/ESG2023En";
import ESG2024En from "@components/main/en/esg/ESG2024En";
import ESG2025En from "@components/main/en/esg/ESG2025En";
import ProductsEn from "@components/main/en/products/ProductsEn";
import DetailEn from "@components/main/en/products/DetailEn";
import NoticeDetailEn from "@components/main/en/notice/NoticeDetailEn";
import NoticeEn from "@components/main/en/notice/NoticeEn";
import ContactDetailEn from "@components/main/en/notice/ContactDetailEn";
import ContactWriteEn from "@components/main/en/notice/ContactWriteEn";
import ContactEn from "@components/main/en/notice/ContactEn";
import FaqEn from "@components/main/en/notice/FaqEn";
import Safety from "@components/main/ko/safety/safety";
import SafetyEn from "@components/main/en/safety/safetyEn";
//보안 관리 페이지 추가
import SecurityDashboard from "@components/admin/management/Security/SecurityManage";
const SuspenseLoader = () => {
    return (_jsx("div", Object.assign({ className: "loading", style: { overflowY: "hidden" } }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) })));
};
const Loader = (Component) => (props) => (_jsx(Suspense, Object.assign({ fallback: _jsx(SuspenseLoader, {}) }, { children: _jsx(Component, Object.assign({}, props)) })));
//Main 포탈 화면
// const WhatWeDo = Loader(lazy(() => import("@components/main/whatwedo/WhatWeDoMain")));
//  /contact 한 라우트에서 ?detail 스위칭
const ContactSwitch = () => {
    const [qs] = useSearchParams();
    const mode = (qs.get("mode") || "").toLowerCase();
    const isDetail = qs.has("detail") || mode === "detail";
    const isWrite = qs.has("write") || mode === "write";
    if (isDetail) {
        return _jsx(ContactDetail, {}); // detail 우선
    }
    else if (isWrite) {
        return _jsx(ContactWrite, {});
    }
    return _jsx(Contact, {});
};
const ContactSwitchEn = () => {
    const [qs] = useSearchParams();
    const mode = (qs.get("mode") || "").toLowerCase();
    const isDetail = qs.has("detail") || mode === "detail";
    const isWrite = qs.has("write") || mode === "write";
    if (isDetail) {
        return _jsx(ContactDetailEn, {}); // detail 우선
    }
    else if (isWrite) {
        return _jsx(ContactWriteEn, {});
    }
    return _jsx(ContactEn, {});
};
const NonticeSwitch = () => {
    const [qs] = useSearchParams();
    const mode = (qs.get("mode") || "").toLowerCase();
    const isDetail = qs.has("detail") || mode === "detail";
    if (isDetail) {
        return _jsx(NoticeDetail, {}); // detail 우선
    }
    return _jsx(Notice, {});
};
const NonticeSwitchEn = () => {
    const [qs] = useSearchParams();
    const mode = (qs.get("mode") || "").toLowerCase();
    const isDetail = qs.has("detail") || mode === "detail";
    if (isDetail) {
        return _jsx(NoticeDetailEn, {}); // detail 우선
    }
    return _jsx(NoticeEn, {});
};
const ProductsSwitch = () => {
    const [qs] = useSearchParams();
    const mode = (qs.get("mode") || "").toLowerCase();
    const isDetail = qs.has("detail") || mode === "detail";
    if (isDetail) {
        return _jsx(Detail, {}); // detail 우선
    }
    return _jsx(Products, {});
};
const ProductsSwitchEn = () => {
    const [qs] = useSearchParams();
    const mode = (qs.get("mode") || "").toLowerCase();
    const isDetail = qs.has("detail") || mode === "detail";
    if (isDetail) {
        return _jsx(DetailEn, {}); // detail 우선
    }
    return _jsx(ProductsEn, {});
};
// ---------- lang=KOR|ENG 쿼리로 언어/URL 동기화 ----------
const normalizeLangParam = (v) => {
    const upper = (v || '').toUpperCase();
    if (upper === 'ENG')
        return 'en';
    // 기본 한국어
    return 'ko';
};
const normalizeParamForUrl = (lng) => (lng === 'en' ? 'ENG' : 'KOR');
// --- ?lang 기반 컴포넌트 스위칭 유틸 ---
const useLangParam = () => {
    const [qs] = useSearchParams();
    const raw = qs.get('lang');
    return normalizeLangParam(raw);
};
// withLangComponent(KoComp, EnComp) -> 현재 ?lang에 따라 컴포넌트 선택 렌더
const withLangComponent = (KoComp, EnComp) => {
    const Switched = (props) => {
        const lng = useLangParam();
        return lng === 'en' ? _jsx(EnComp, Object.assign({}, props)) : _jsx(KoComp, Object.assign({}, props));
    };
    return Switched;
};
// 예: main 전용 스위칭 라우트 컴포넌트
const HomeMainRoute = withLangComponent(HomeMain, HomeMainEn);
const CompanyRoute = withLangComponent(Company, CompanyEn);
const HistoryRoute = withLangComponent(History, HistoryEn);
const GoalsRoute = withLangComponent(Goals, GoalsEn);
const LocationRoute = withLangComponent(Location, LocationEn);
const RegistrationRoute = withLangComponent(Registration, RegistrationEn);
const ESG2023Route = withLangComponent(ESG2023, ESG2023En);
const ESG2024Route = withLangComponent(ESG2024, ESG2024En);
const ESG2025Route = withLangComponent(ESG2025, ESG2025En);
const FaqRoute = withLangComponent(Faq, FaqEn);
const NonticeRoute = withLangComponent(NonticeSwitch, NonticeSwitchEn);
const ContactRoute = withLangComponent(ContactSwitch, ContactSwitchEn);
const ProductsRoute = withLangComponent(ProductsSwitch, ProductsSwitchEn);
const SafetyRoute = withLangComponent(Safety, SafetyEn);
const SecurityRoute = withLangComponent(SecurityDashboard, SecurityDashboard);
// 쿼리의 ?lang=KOR|ENG 을 읽어 i18n.language와 동기화하고,
// 쿼리가 없으면 기본값(KOR)으로 교정해주는 게이트 컴포넌트
const LangQueryGate = ({ children }) => {
    const [qs] = useSearchParams();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const raw = qs.get('lang');
    const lng = normalizeLangParam(raw);
    // 1) i18n 언어 동기화
    useEffect(() => {
        if (i18n.language !== lng) {
            i18n.changeLanguage(lng);
        }
    }, [lng]);
    // 2) 쿼리 누락 시 ?lang=KOR 기본값으로 URL 보정
    useEffect(() => {
        if (!raw) {
            const url = `${pathname}?lang=${normalizeParamForUrl(lng)}`;
            navigate(url, { replace: true });
        }
    }, [raw, pathname, lng, navigate]);
    return _jsx(_Fragment, { children: children });
};
// PublicRoute에 넣기 편하도록 래퍼 컴포넌트
const MainPortalWithLang = () => (_jsx(LangQueryGate, { children: _jsx(MainPortalLayout, {}) }));
const routes = [
    {
        element: _jsx(PublicRoute, { component: null }),
        children: [
            {
                path: "/",
                element: _jsx(Navigate, { to: `${Const.URL_MAIN}?lang=KOR`, replace: true }),
            },
            {
                path: Const.URL_LOGIN,
                element: _jsx(Login, {}),
            },
        ],
    },
    {
        element: _jsx(PublicRoute, { component: MainPortalWithLang }),
        children: [
            { path: Const.URL_MAIN, element: _jsx(HomeMainRoute, {}) },
            { path: Const.URL_COMPANY, element: _jsx(CompanyRoute, {}), },
            { path: Const.URL_HISTORY, element: _jsx(HistoryRoute, {}), },
            { path: Const.URL_GOALS, element: _jsx(GoalsRoute, {}), },
            { path: Const.URL_REGISTRATION, element: _jsx(RegistrationRoute, {}), },
            { path: Const.URL_LOCATION, element: _jsx(LocationRoute, {}), },
            { path: Const.URL_2023ESG, element: _jsx(ESG2023Route, {}), },
            { path: Const.URL_2024ESG, element: _jsx(ESG2024Route, {}), },
            { path: Const.URL_2025ESG, element: _jsx(ESG2025Route, {}), },
            { path: Const.URL_NOTICE, element: _jsx(NonticeRoute, {}), },
            { path: Const.URL_FAQ, element: _jsx(FaqRoute, {}), },
            { path: Const.URL_CONTACT, element: _jsx(ContactRoute, {}) },
            { path: Const.URL_SAFETY, element: _jsx(SafetyRoute, {}) },
            { path: "*", element: _jsx(ProductsRoute, {}), },
        ],
    },
    //로그인 등 토큰이나 보안으로 필요한경우 사용 하거나 
    {
        element: _jsx(PrivateRoute, { component: AdminLayout }),
        children: [
            {
                path: Const.URL_ADMIN,
                element: _jsx(MenuMain, {}),
            }, {
                path: Const.URL_PRODUCTSMANAGEMENT,
                element: _jsx(ProductMain, {}),
            },
            {
                path: Const.URL_BOARDMANAGEMENT,
                element: _jsx(BoardMain, {}),
            },
            { path: Const.URL_SECURITY,
                element: _jsx(SecurityRoute, {})
            },
        ],
    },
    {
        path: "*",
        element: _jsx(Navigate, { to: `${Const.URL_MAIN}?lang=KOR`, replace: true }),
    },
    // 404, 서비스에러 등 필요시
    /*  {
       path: "*",
       element: <Navigate to={Const.URL_NOT_FOUND} replace />,
     },
     {
       element: <PublicRoute component={null} />,
       children: [
         {
           path: Const.URL_NOT_FOUND,
           element: <NotFound />,
         },
         {
           path: Const.URL_SYSTEM_ERROR,
           element: <SystemError />,
         },
       ],
     }, */
];
export default routes;
